var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../utils/mobx/decorators/memoize';
import { runtime } from '../runtime/Runtime';
export class ModelAvailable {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get model() {
        return this.parent;
    }
    createProxy(type) {
        return new Proxy(this, {
            get(modelAvailable, lookup) {
                if (!runtime.persistent.entityData(type, lookup).isAvailable)
                    return null;
                return modelAvailable.model.stream.entityByTypeAndId(type, lookup);
            },
        });
    }
    get path() {
        return this.createProxy('path');
    }
    get topic() {
        return this.createProxy('topic');
    }
    get question() {
        return this.createProxy('question');
    }
    get bundle() {
        return this.createProxy('bundle');
    }
}
__decorate([
    memoize
], ModelAvailable.prototype, "path", null);
__decorate([
    memoize
], ModelAvailable.prototype, "topic", null);
__decorate([
    memoize
], ModelAvailable.prototype, "question", null);
__decorate([
    memoize
], ModelAvailable.prototype, "bundle", null);
